import { lazy } from 'react'

export const BlackFridayOffer = lazy(() => import('./BlackFridayOffer'))
